export default __webpack_public_path__ + "assets/12.b7746ec8.png";